import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalStorage } from 'src/app/core/Gloabl/Global';
import { environment } from '../../../../../environments/environment.prod';
import { IProfile } from '../UserDetails/user.model';
import { UserProfile } from '../UserDetails/user.profile';
import { Notification } from '../../../../core/Notifications/Notification';

@Component({
  selector: 'app-hospital-login',
  templateUrl: './hospital-login.component.html',
  styleUrls: ['./hospital-login.component.scss']
})
export class HospitalLoginComponent implements OnInit {
  loginform: FormGroup;
  clientId = 'Global_spa';
  constructor(
    private fb: FormBuilder,
    private router: Router, private Http: HttpClient, private notify: Notification
    , private global: GlobalStorage, private authProfile: UserProfile
  ) {
    this.loginform = this.fb.group({
      'username': ['', [Validators.pattern("[0-9]{10}$"), this.nameValidator, Validators.minLength(10), Validators.maxLength(10), Validators.required]],
      'password': ['', [Validators.required, Validators.minLength(6)]],
    })
  }
  public checkError = (controlName: string, errorName: string) => {
    return this.loginform.controls[controlName].hasError(errorName);
   }

  ngOnInit(): void {
  }

  nameValidator(control: any): { [key: string]: boolean } {
    const nameRegexp: RegExp = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?/\s/g,''/a-zA-Z]/;
    // const spaceexp: RegExp =/[/\s/g, '']/

    if (control.value && nameRegexp.test(control.value)) {
      return { invalidName: true };
    }
  }
  onSubmit() {
    const header = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' });
    const params = new HttpParams()
      .append('username', this.loginform.value.username)
      .append('password', this.loginform.value.password)
      .append('client_id', this.clientId)
      .append('grant_type', 'phone_number_token')
      .append('client_secret', 'secret')
      .append('role','hospital')
    //.append('scope', 'Global_api');
    this.Http.post(`${environment.Login_URL}` + `connect/token`, params, { headers: header })
      .subscribe((res: any) => {
        localStorage.setItem('access_token', res.access_token)
        localStorage.setItem('expires_in', res.expires_in)
        this.notify.successmsg("Welcome to The Hospital Portal" + " logged Successfully .");
        var userProfile: IProfile = res;
        this.authProfile.setProfile(userProfile);
        // this.router.navigate([""]);
        console.log(res)
      }, (error) => {
        this.notify.errorsmsg(error)
      })
  }
}

